<template>
  <div class="page-container">
    <div class="list">
      <div
        class="item"
        v-for="item in list"
        :key="item.id"
        @click="onClickItem(item)"
      >
        <img fit="cover" :src="item.coverImage" />
        <div class="info">
          <div class="title">{{ item.title }}</div>
          <div class="desc">
            {{ item.address }}
          </div>
        </div>
      </div>
    </div>
    <video
      v-show="videoShow"
      ref="videoPlayer"
      class="video-container"
      @fullscreenchange="onVideoFullScreenChange"
    />
  </div>
</template>

<script>
function buildFullUrl (url) {
  return 'https://sxbwygzh.oss-cn-beijing.aliyuncs.com/jin-hun' + url
}

export default {
  name: 'JinHunIndex',
  data () {
    return {
      list: [
        {
          id: 1,
          title: '文明摇篮',
          coverImage: buildFullUrl('/images/1.jpg'),
          videoSrc: buildFullUrl('/videos/1.mp4'),
          address: '山西博物院主馆二层'
        },
        {
          id: 2,
          title: '夏商踪迹',
          coverImage: buildFullUrl('/images/2.jpg'),
          videoSrc: buildFullUrl('/videos/2.mp4'),
          address: '山西博物院主馆二层'
        },
        {
          id: 3,
          title: '晋国霸业',
          coverImage: buildFullUrl('/images/3.jpg'),
          videoSrc: buildFullUrl('/videos/3.mp4'),
          address: '山西博物院主馆二层'
        },
        {
          id: 4,
          title: '民族熔炉',
          coverImage: buildFullUrl('/images/4.jpg'),
          videoSrc: buildFullUrl('/videos/4.mp4'),
          address: '山西博物院主馆三层'
        },
        {
          id: 5,
          title: '佛风遗韵',
          coverImage: buildFullUrl('/images/5.jpg'),
          videoSrc: buildFullUrl('/videos/5.mp4'),
          address: '山西博物院主馆三层'
        },
        {
          id: 6,
          title: '戏曲故乡',
          coverImage: buildFullUrl('/images/6.jpg'),
          videoSrc: buildFullUrl('/videos/6.mp4'),
          address: '山西博物院主馆三层'
        },
        {
          id: 7,
          title: '天下晋商',
          coverImage: buildFullUrl('/images/7.jpg'),
          videoSrc: buildFullUrl('/videos/7.mp4'),
          address: '山西博物院主馆三层'
        }
      ],
      videoShow: false
    }
  },
  methods: {
    async onClickItem (item) {
      this.videoShow = true

      await this.$nextTick()

      const video = this.$refs.videoPlayer
      video.src = item.videoSrc
      video.currentTime = 0

      await video.play()
      video.controls = true

      setTimeout(() => {
        video.requestFullscreen()
      }, 500)
    },
    onVideoFullScreenChange () {
      if (!document.fullscreenElement) {
        this.$refs.videoPlayer.pause()
        this.videoShow = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
